import styled from 'styled-components';

import FrontImage from '../../../assets/images/LandingPage/frontImg.png';
import theme from '../../../assets/theme';
import HybridForm from '../../../components/_organisms/HybridForm/HybridForm';
import { NextPageWithLayout } from '../../../components/layouts';
import LandingPageLayout from '../../../components/layouts/LandingPageLayout';

const ConferenceSalesPage: NextPageWithLayout = () => {
  return (
    <LandingPageLayout
      title="Conference Meeting"
      subTitle="Interested in bringing Curipod to your school or district?"
      primaryActionText="Conference Meeting"
      image={FrontImage}
      hideBlobs={false}
      disableHeadline={true}
    >
      <PageContainer>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>
          Schedule a meeting with Curipod
        </h1>
        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>
          Fill out the form below to schedule a meeting with Curipod
        </h4>
        <HybridForm
          typeformUrl="https://9uq31r57i3q.typeform.com/to/SXOOixzl"
          showTypeformEnding={true}
          thankYouMessage="Thank you for your interest in Curipod! We will be in touch soon."
          metricEventNamePrefix="ConferenceLead"
        />
      </PageContainer>
    </LandingPageLayout>
  );
};

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  background: ${theme.colors.background};
`;

export default ConferenceSalesPage;
